import { AuthAction } from "@/model/data/authActions/AuthAction";
import { AuthActionTypeEnum } from "@/model/data/authActions/AuthActionTypeEnum";
import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/license/aareq_download/delete_installations";

export class DeleteInstallationsRequestDownloadCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    params: any = null;

    constructor(installationNames: string[]) {
        super();
        this.params = installationNames;
        this.responseType = "text";
    }

    public async execute(): Promise<AxiosResponse> {
        console.debug("DeleteInstallationsRequestDownloadCommand.execute()");
        return await this.executeCommand(this.params);
    }
}
